<template>
    <div class="chat">
        <div class="row">
            <h2 class="col">Guest Chat</h2>
        </div>

        <div class="row chat-content">
            <div class="col-4 chat-all-conv">

                <Spinner v-if="loading"/>

                <ul v-else-if="chats">
                    <li v-for="(chat, index) in chats.content" v-bind:key="index" v-on:click="selectChat(chat.reference)">
                        <div class="row" v-bind:class="{'chat-all-conv--selected' : selectedChat && chat.reference === selectedChat.reference}">
                            <div class="col-2 chat-icon">
                                <i class="fas fa-user"></i>
                            </div>
                            <div class="col-10 chat-summ">
                                <div class="row">
                                    <div class="col-8 chat-summ--name">{{chat.guestProfileName}}</div>
                                    <div class="col-4 chat-summ--date"  v-bind:class="{'chat-summ--date--selected' : selectedChat && chat.reference === selectedChat.reference}">{{smartTimeOrDate(chat.lastMessage.created)}}</div>
                                    <div class="col-11 chat-summ--text">{{chat.lastMessage.content}}</div>
                                    <div v-if="chat.unreadCount > 0" class="col-1 chat-summ--unread-cnt text-right"><span>{{chat.unreadCount}}</span></div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-if="chats.length === 0">
                        You don't yet have any chats with guests
                    </li>
                    <li v-if="canLoadMoreChats" class="text-center">
                      <button v-on:click="moreChats()" class="btn btn-secondary w-auto">More</button>
                    </li>
                </ul>
            </div>

            <div class="col-8 chat-conv-detail">
                <template v-if="selectedChat">
                    <div class="col chat-conv-detail__contact">
                        <div class="row">
                            <div class="col-4 col chat-conv-detail__contact__details">
<!--                                <div>Image</div>-->
                                <div><h5>{{selectedChat.guestProfileName}}</h5></div>
                                <div>{{selectedChat.guestMobile}}</div>
                            </div>
                            <div class="col-8  chat-conv-detail__contact__bookings">
                                <table>
                                    <thead>
                                        <th><i class="fas fa-door-open"></i></th>
                                        <th><i class="fas fa-door-closed"></i></th>
                                        <th><i class="fas fa-bed"></i></th>
                                        <th><i class="fas fa-male adult"></i><i class="fas fa-male adult"></i></th>
                                    </thead>
                                    <tr v-for="(booking) in selectedChat.bookings" v-bind:key="booking.reference" v-on:click="openBooking(booking)">
                                        <td>{{friendlyDate(booking.arrival)}}</td>
                                        <td>{{friendlyDate(booking.departure)}}</td>
                                        <td>
                                            <span v-for="(room, index) in booking.rooms" v-bind:key="room.reference">
                                                <template v-if="index > 0">,</template>
                                                {{room.name}}
                                            </span>
                                        </td>
                                        <td>{{getTotalGuestsForBooking(booking)}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="chat-conv-detail__divider"><div></div></div>

                    <div ref="messagesWindow" class="chat-conv-detail__messages-scrollable">

                        <div v-if="!selectedChat.messages.hasNext" class="text-center text-muted">
                            All messages loaded
                        </div>

                        <Spinner class="" v-show="loadingMessages"/>

                        <div class="chat-conv-detail__messages">
                            <div v-for="(message, index) in selectedChat.messages.content" v-bind:key="index">
                                <div class="message w-75 mb-3" v-bind:class="{'ml-auto' : isHostMessage(message) || isSystemMessage(message)}">
                                    <div class="rounded py-2 px-3 mb-2" v-bind:class="{'message--host': isHostMessage(message), 'message--guest' : isGuestMessage(message), 'message--system' : isSystemMessage(message)}">
                                        <p class="text-small mb-0">{{message.content}}</p>
                                    </div>
                                    <p class="small text-muted text-right">
                                        {{friendlyChatTime(message.created)}}
                                        &nbsp;&nbsp;|&nbsp;&nbsp;
                                        {{friendlyChatDateShort(message.created)}}
                                        <span v-if="!isGuestMessage(message) && (isMessageRead(message) || isMessageDelivered(message))" class="message__ticks" v-bind:class="{'message__ticks--read' : isMessageRead(message)}"><i class="fas fa-check"></i><i class="fas fa-check"></i></span>
                                        <span v-if="isSystemMessage(message)" class="message__auto"><i class="fas fa-cogs"></i></span>
                                    </p>
                                </div>
<!--                                <div v-if="isGuestMessage(message)" class="w-10 message__translate"><i class="fas fa-language"></i></div>-->

                                <div v-if="selectedChat.unreadCount > 0 && message.showUnread" class="chat-conv-detail__messages__unread-bar">
                                    {{selectedChat.unreadCount}} UNREAD MESSAGE<template v-if="selectedChat.unreadCount > 1">S</template>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="chat-conv-detail__new-message-bar">
                        <template v-if="!errorSendingMessage">
                            <div class="chat-conv-detail__new-message-bar__add" v-bind:class="{'chat-conv-detail__new-message-bar__add--cta' : !selectedChat.utilityConversationWindowOpen}">
                                <button v-show="!sendingMessage"
                                        v-on:click.stop="showAddContentDialog"
                                        class="btn"><i class="fas fa-plus"></i></button>
                            </div>

                            <input v-if="selectedChat.utilityConversationWindowOpen" type="text" v-model="newMessage" v-on:keyup.enter="sendMessage" ref="newMessage">

                            <div v-else class="chat-conv-detail__new-message-bar__no-conv">
                                <i class="fas fa-arrow-left"></i>
                                No open conversation - use a WhatsApp approved Template to start one.
                            </div>

                            <div class="chat-conv-detail__new-message-bar__action">
                                <Spinner class="chat-conv-detail__new-message-bar__spinner" v-show="sendingMessage"/>
                                <button v-show="!sendingMessage"
                                        v-on:click="sendMessage"
                                        v-bind:class="{'btn-disabled' : !newMessage}"
                                        class="btn btn-primary"><i class="fas fa-paper-plane fa-rotate-by"></i></button>
                            </div>
                        </template>
                        <template v-else>
                          <div class="alert alert-danger w-100" role="alert">
                            {{errorSendingMessage}}
                            <button v-on:click="clearSendingMessageError()" class="close" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </template>
                    </div>
                </template>

                <template v-else>
                    <div class="chat-conv-detail--no-chat-selected">
                        <i class="fas fa-comments"></i>
<!--                        <i class="fab fa-whatsapp"></i>-->
                        <h3>WhatsApp chats by BetterGuest</h3>
                    </div>
                </template>

            </div>
        </div>

        <add-content-dialog v-bind:selectedChat="selectedChat" v-if="showingAddContentDialog"></add-content-dialog>
        <add-using-template-dialog v-bind:selectedChat="selectedChat" v-if="showingUsingTemplateDialog"></add-using-template-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';

    import { store } from '../store.js'

    import Spinner from '../components/Spinner.vue'
    import AddContentDialog from '../components/whatsapp/AddContentDialog'
    import AddUsingTemplateDialog from '../components/whatsapp/AddUsingTemplateDialog'

    import {datesMixin} from "../mixins/DatesMixin"
    import {bookingsMixin} from "../mixins/BookingsMixin"

    export default {
        name: 'GuestChats',
        components: { Spinner, AddContentDialog, AddUsingTemplateDialog },
        mixins: [datesMixin, bookingsMixin],
        data: function () {
            return {
                chats: null,
                selectedChat: null,
                unreadStartMessage: null,
                loading: true,
                loadingMessages: false,
                chatPageNumber: 0,
                chatPageSize: 10,
                chatMessagesPageNumber: 0,
                chatMessagesPageSize: 10,
                showingAddContentDialog: false,
                showingUsingTemplateDialog: false,
                newMessage: "",
                sendingMessage: false,
                errorSendingMessage: null,
                showTripDetails: false,
                trip: null,
            }
        },
        computed: {
          canLoadMoreChats: function () {
              if (this.chats && this.chats.hasNext) {
                return true;
              }
              return false;
          }
        },
        methods: {
            fetchPageOfChats: function (callback) {
                this.loading = true;
                let params = {
                    pageNumber: this.chatPageNumber,
                    pageSize: this.chatPageSize
                };
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/chats', {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchFirstPageOfChats: function() {
                this.fetchPageOfChats((pageOfChats) => {
                    console.log(pageOfChats)
                    this.chats = pageOfChats;
                })
            },
            moreChats: function () {
                this.chatPageNumber++;
                console.log("fetching page of chats: " + this.chatPageNumber)
                this.fetchPageOfChats((pageOfChats) => {
                    console.log(pageOfChats)
                    this.chats.content.push(...pageOfChats.content)
                    this.chats.hasNext = pageOfChats.hasNext;
                    this.chats.hasPrevious = pageOfChats.hasPrevious;
                })
            },
            fetchChat: async function (reference, callback) {
                this.loading = true;
                return this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/chats/' + reference, {
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchPageOfMessages: function (callback) {
                this.loadingMessages = true;
                let params = {
                    pageNumber: this.chatMessagesPageNumber,
                    pageSize: this.chatMessagesPageSize
                };
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/chats/' + this.selectedChat.reference + '/messages', {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loadingMessages = false
                })
            },
            selectChat: async function(reference) {
                console.log("Selected chat " + reference);
                this.selectedChat = null;
                await this.chatRead();
                await this.fetchChatAndUpdateUI(reference);
            },
            fetchChatAndUpdateUI: async function(reference) {
                return this.fetchChat(reference, (chat) => {
                    this.selectedChat = chat;
                    this.findFirstUnreadMessage();
                    this.$nextTick(() => {
                        this.$refs.messagesWindow.addEventListener("scroll", this.scrollHandler);
                        this.scrollToEndOfChat();
                    });
                    this.fetchGuestBookings(this.selectedChat.guestMobile);
                })
            },
            findFirstUnreadMessage: function() {
                if (this.selectedChat && this.selectedChat.messages) {
                    let lastUnread = this.selectedChat.messages.content.findLast(message => {
                        if (this.isHostMessage(message) || this.isSystemMessage(message)) {
                            return true;
                        }
                        if (this.isMessageRead(message)) {
                            return true;
                        }
                        return false;
                    });
                    console.log(lastUnread);
                    if (lastUnread) {
                        lastUnread.showUnread = true;
                        this.unreadStartMessage = lastUnread;
                    }
                }
            },
            moreMessages: function () {
                if (this.selectedChat && this.selectedChat.messages.hasNext) {
                    console.log("fetching page of messages: " + this.chatMessagesPageNumber);
                    this.chatMessagesPageNumber++;
                    this.fetchPageOfMessages((pageOfMessages) => {
                        console.log(pageOfMessages)
                        this.selectedChat.messages.content.unshift(...pageOfMessages.content);
                        this.selectedChat.messages.hasNext = pageOfMessages.hasNext;
                    })
                }
            },
            scrollToEndOfChat: function() {
                this.$refs.messagesWindow.scrollTo(0, this.$refs.messagesWindow.scrollHeight);
            },
            scrollHandler: function() {
                console.log("Scrolling");
                let topOfWindow = this.$refs.messagesWindow.scrollTop === 0;
                if (topOfWindow) {
                    console.log("Scrolled to TOP");
                    this.moreMessages();
                }
            },
            isHostMessage: function(message) {
                if (message && message.sentBy === 'host') {
                    return true;
                } else {
                    return false;
                }
            },
            isGuestMessage: function(message) {
                if (message && message.sentBy === 'guest') {
                    return true;
                } else {
                    return false;
                }
            },
            isSystemMessage: function(message) {
                if (message && message.sentBy === 'system') {
                    return true;
                } else {
                    return false;
                }
            },
            isMessageRead: function(message) {
                if (message && message.status === 'read') {
                    return true;
                } else {
                    return false;
                }
            },
            isMessageDelivered: function(message) {
                if (message && message.status === 'delivered') {
                    return true;
                } else {
                    return false;
                }
            },
            chatRead: async function() {
                console.log("Checking if need to mark chat as read");
                if (this.selectedChat && this.selectedChat.unreadCount > 0) {
                    console.log("Need to mark chat as read");
                    await this.$http.post('/guest-management/v1/companies/' + store.host.company.reference + '/chats/' + this.selectedChat.reference + '/read');
                    for (let chat of this.chats.content) {
                        if (chat.reference === this.selectedChat.reference) {
                            chat.unreadCount = 0;
                        }
                    }
                }
                this.$root.$emit('chat-unread-count-updated');
            },
            showAddContentDialog: function() {
                if (this.selectedChat.utilityConversationWindowOpen) {
                    this.showingAddContentDialog = true;
                } else {
                    this.showingUsingTemplateDialog = true;
                }
            },
            hideAddContentDialog: function(type) {
                this.showingAddContentDialog = false;
                switch (type) {
                    case 'template':
                        this.showingUsingTemplateDialog = true;
                        break;
                }
            },
            hideUseTemplateDialog: function() {
                this.showingUsingTemplateDialog = false;
            },
            hideUseTemplateDialogAndSendFreeFormMessage: function(message) {
                this.showingUsingTemplateDialog = false;
                this.newMessage = message;
                this.sendMessage();
            },
            hideUseTemplateDialogAndSendTemplateMessage: function(templateReference, bookingReference) {
                this.showingUsingTemplateDialog = false;
                this.sendTemplateMessage(templateReference, bookingReference);
            },
            sendMessage: function() {
                console.log("Sending message: " + this.newMessage);

                this.chatRead();
                this.sendingMessage = true;

                const body = {
                    content: this.newMessage
                };

                this.$http.post('/guest-management/v1/companies/' + store.host.company.reference + '/chats/' + this.selectedChat.reference + '/send', body, {'axios-retry': {retries: 0}}
                ).then(response => {
                    this.selectedChat.messages.content.push(response.data);
                    this.newMessage = "";
                    this.$refs.newMessage.focus();
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.errorSendingMessage = error.response.data.message;
                    } else {
                        this.errorSendingMessage = "There was a problem sending your message. Please try again.";
                    }
                }).finally(() => {
                    this.sendingMessage = false;
                });
            },
            sendTemplateMessage: function(templateReference, bookingReference) {
                console.log("Sending template message: " + this.newMessage);

                this.chatRead();
                this.sendingMessage = true;

                const body = {
                    templateReference: templateReference,
                    bookingReference: bookingReference
                };

                this.$http.post('/guest-management/v1/companies/' + store.host.company.reference + '/chats/' + this.selectedChat.reference + '/send-template', body, {'axios-retry': {retries: 0}}
                ).then(response => {
                    this.selectedChat.messages.content.push(response.data);
                    this.newMessage = "";
                    this.$refs.newMessage.focus();
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.errorSendingMessage = error.response.data.message;
                    } else {
                        this.errorSendingMessage = "There was a problem sending your template message. Please try again.";
                    }
                }).finally(() => {
                    this.sendingMessage = false;
                });
            },
            clearSendingMessageError: function () {
                this.errorSendingMessage = null;
            },
            showTrip: function (booking) {
                this.trip = booking;
                this.showTripDetails = true;
            },
            hideTrip: function () {
                this.showTripDetails = false;
                this.trip = null;
            },
            chatUpdated: function(updatedChat) {
                for (let chat of this.chats.content) {
                    if (chat.reference === this.selectedChat.reference) {
                        Object.assign(chat, updatedChat);
                    }
                }
                if (this.selectedChat && this.selectedChat.reference === updatedChat.reference) {
                    this.fetchChatAndUpdateUI(updatedChat.reference);
                }
            },
            fetchGuestBookings: async function(mobile) {
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/search-mobile';
                try {
                    let response = await this.$http.get(url, {
                        params: {
                            mobile: mobile
                        },
                        withCredentials: true
                    });
                    Vue.set(this.selectedChat, 'bookings', response.data);
                } catch (error) {
                    console.log(error);
                }
            },
            openBooking: function(booking) {
                this.$root.$emit('open-trip-details', booking);
            }
        },
        mounted() {
            console.log("Loading chats");
            this.fetchFirstPageOfChats();

            this.$root.$on('chat-updated', this.chatUpdated);
            this.$root.$on('finished-chat-choosing-content-type', this.hideAddContentDialog);
            this.$root.$on('close-using-template-dialog', this.hideUseTemplateDialog);
            this.$root.$on('send-free-form-message', this.hideUseTemplateDialogAndSendFreeFormMessage);
            this.$root.$on('send-template-message', this.hideUseTemplateDialogAndSendTemplateMessage);
        },
        beforeDestroy () {
            if (this.$refs.messagesWindow) {
              this.$refs.messagesWindow.removeEventListener("scroll", this.scrollHandler);
            }
            this.chatRead();

            this.$root.$off('chat-updated', this.chatUpdated);
            this.$root.$off('finished-chat-choosing-content-type', this.hideAddContentDialog);
            this.$root.$off('close-using-template-dialog', this.hideUseTemplateDialog);
            this.$root.$off('send-free-form-message', this.hideUseTemplateDialogAndSendFreeFormMessage);
            this.$root.$off('send-template-message', this.hideUseTemplateDialogAndSendTemplateMessage);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/chat";
    @import "../styles/layout/forms.scss";
</style>